import React, { useMemo, useState, useEffect } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";
import ReactModal from "react-modal";
import Cookies from "universal-cookie";
import {
  capacidadPorSolicitud,
  obtenerCapacidadInstalada,
} from "../../Services/Rest";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";

const InfoCapacidadInstalada = (props) => {
  const urlA = obtenerCapacidadInstalada;
  const urlU = capacidadPorSolicitud;
  const cookie = new Cookies();

  if (cookie.get("tipo_Usuario") == 1) {
    var urlendpoint = urlA;
  }
  if (cookie.get("tipo_Usuario") == 2) {
    var urlendpoint = urlU + cookie.get("institucionid");
  }
  if (cookie.get("tipo_Usuario") == 3) {
    var urlendpoint = urlU + props.institucionId;
  }
  if (cookie.get("tipo_Usuario") == 4) var urlendpoint = urlA;
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "Id",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "sede",
        header: "Sede",
        filterVariant: "text",
      },
      {
        accessorKey: "totalCamillasObservacionUrgencias",
        header: "Total Camillas Observación Urgencias",
        filterVariant: "text",
      },
      {
        accessorKey: "totalCamas",
        header: "Total Camas",
        filterVariant: "text",
      },
      {
        accessorKey: "consultoriosMedicos",
        header: "Consultorios Medicos",
        filterVariant: "text",
      },
      {
        accessorKey: "sitiosMuestrasLaboratorioClinico",
        header: "Sitios De  Muestras Laboratorio Clinico",
        filterVariant: "text",
      },
      {
        accessorKey: "unidadesOdontologicas",
        header: "Unidades Odontologicas",
        filterVariant: "text",
      },
      {
        accessorKey: "radiologiaImagenesDiagnosticas",
        header: "Consultorios o Salas Radiologia e Imagenes Diagnosticas",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "terapias",
        header: "Consultorios o Salas de Terapias",
        filterVariant: "text",
      },
      {
        accessorKey: "nombreInstitucion",
        header: "Institución",
        filterVariant: "text",
        enableEditing: false,
      },
      {
        accessorKey: "fechaCorte",
        header: "Fecha Corte",
        filterVariant: "text",
      },
    ],
    [],
  );
  const [list1, setList1] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList1]);

  const [tableData, setTableData] = useState(() => list1);
  const handleSaveRow = async ({ exitEditingMode, row, values }) => {
    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaCapacidad?Id=" +
        values.id,
      data: values,
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });

    //send/receive api updates here
    setTableData([...tableData]);
    exitEditingMode(); //required to exit editing mode
    console.log("post data ");
    console.log(values.id);
  };
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <div>
      {cookie.get("tipo_Usuario") == 2 ? (
        <button
          variant="contained"
          className="btn btn-primary"
          color="primary"
          onClick={handleOpenModalTest}
        >
          {" "}
          Información Capacidad Instalada
        </button>
      ) : (
        <button
          variant="contained"
          className="btn btn-light"
          color="primary"
          onClick={handleOpenModalTest}
        >
          {" "}
          Información Capacidad Instalada
        </button>
      )}
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          overlay: { zIndex: 2000 },
        }}
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Capacidad Instalada
                  </h6>
                  <hr />

                  <div className="row"></div>

                  <hr />

                  <MaterialReactTable
                    title="indicadores"
                    columns={columns}
                    data={list1}
                    initialState={{ showColumnFilters: true }}
                    enableEditing
                    onEditingRowSave={handleSaveRow}
                    renderRowActions={({ row, table }) => (
                      <Box sx={{ display: "flex", gap: "1rem" }}>
                        {cookie.get("tipo_Usuario") == 2 ? (
                          <Tooltip arrow placement="left" title="Edit">
                            <IconButton
                              onClick={() => table.setEditingRow(row)}
                            >
                              <Edit />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <></>
                        )}
                      </Box>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export default InfoCapacidadInstalada;
